// CLEANUP: simple stub/wrapper around console methods
/* eslint-disable no-console */
export default (message, level) => {
  if (process.env.NODE_ENV === 'test') {
    return;
  }
  switch (level) {
    case 'error':
      console.error(message);
      break;
    default:
      console.log(message);
  }
};
